// hooks/useFeedbacks.js
import { useState, useCallback, useEffect } from "react";
import axios from "axios";

const useFeedbacks = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const fetchFeedbacks = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://backend-my-portfolio.onrender.com/api/feedback?page=${page}&limit=10`
      );
      if (response.data.length > 0) {
        setFeedbacks((prevFeedbacks) => [...prevFeedbacks, ...response.data]);
        setPage((prevPage) => prevPage + 1);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Erro ao buscar feedbacks:", error);
    } finally {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => {
    fetchFeedbacks();
  }, [fetchFeedbacks]);

  const addFeedback = (newFeedback) => {
    setFeedbacks((prevFeedbacks) => [newFeedback, ...prevFeedbacks]);
  };

  return { feedbacks, loading, hasMore, fetchFeedbacks, addFeedback };
};

export default useFeedbacks;
